import { components } from 'react-select';

export const CustomOption = props => {
  return (
    <components.Option {...props}>
      <div className="report-options-recipient-selector-row">
        <input
          className="report-options-recipient-selector-checkbox"
          id={`checkbox-${props.data.label}`}
          type="checkbox"
          value={props.data.label}
          checked={props.isSelected}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );
};
